import type { QuestionTemplate, TopicId } from '../types';
import { FRAC_TEMPLATES } from './frac';
import { INMM_TEMPLATES } from './inmm';
import { TENTHS_TEMPLATES } from './tenths';
import { TOL_TEMPLATES } from './tol';
import { SPEEDS_TEMPLATES } from './speeds';
import { TRIG_TEMPLATES } from './trig';
import { BOLT_TEMPLATES } from './bolt';
import { TAPER_TEMPLATES } from './taper';
import { THREAD_TEMPLATES } from './threads';
import { PRINT_TEMPLATES } from './print';
import { STOCK_TEMPLATES } from './stock';
import { RATIO_TEMPLATES } from './ratio';
import { SINEBAR_TEMPLATES } from './sinebar';

export const TEMPLATES: readonly QuestionTemplate[] = [
  ...FRAC_TEMPLATES,
  ...INMM_TEMPLATES,
  ...TENTHS_TEMPLATES,
  ...TOL_TEMPLATES,
  ...SPEEDS_TEMPLATES,
  ...TRIG_TEMPLATES,
  ...BOLT_TEMPLATES,
  ...TAPER_TEMPLATES,
  ...THREAD_TEMPLATES,
  ...PRINT_TEMPLATES,
  ...STOCK_TEMPLATES,
  ...RATIO_TEMPLATES,
  ...SINEBAR_TEMPLATES,
];

export const TEMPLATE_BY_ID: ReadonlyMap<string, QuestionTemplate> = new Map(
  TEMPLATES.map((t) => [t.id, t]),
);

export function templatesForTopic(topicId: TopicId): QuestionTemplate[] {
  return TEMPLATES.filter((t) => t.topicId === topicId);
}
